import { Button } from "@/shared/components/ui/button"
import { mergeClasses } from "@/shared/utils/cn"
import { Link, useLocation } from "react-router-dom"
import { navItems } from "@/app/router/Router"
import { useAuth } from "@/app/providers"
import { LogOut } from "lucide-react"
import { ROUTES } from "@/app/router/routes";
import type { NavItem } from "@/app/router/router.types";

function NavItemLink({ item }: { item: NavItem }) {
  const location = useLocation();
  const isActive = item.href === "/"
    ? location.pathname === "/"
    : location.pathname.startsWith(item.href);

  return (
    <Link
      to={item.href}
      className={mergeClasses(
        "px-4 py-2 rounded-md text-sm font-medium flex items-center gap-2",
        "hover:bg-gray-100 transition-colors",
        isActive
          ? "text-blue-600 bg-blue-50"
          : "text-gray-700 hover:text-gray-900"
      )}
    >
      {item.label}
    </Link>
  );
}

function TopNavBar() {
  const { user } = useAuth();

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-white shadow-sm">
      <div className="flex h-16 items-center px-4 lg:px-8 gap-4">
        {/* App Name */}
        <div className="flex items-center gap-2 mr-6">
          <img src="/logo.png" alt="Craig Admin" title="Craig Admin" className="h-8" />
        </div>

        {/* Navigation Links */}
        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <NavItemLink key={item.href} item={item} />
          ))}
        </nav>

        <div className="flex-1" />

        {/* Actions */}
        <div className="flex items-center gap-2">
          {user && (
            <span className="text-sm text-gray-700 hidden md:inline">
              {user.userName}
            </span>
          )}
          <Link to={ROUTES.logout}>
            <Button variant="ghost" size="icon">
              <LogOut className="h-5 w-5" />
            </Button>
          </Link>
        </div>
      </div>
    </header>
  );
}

export default TopNavBar;
